(() => {
    // ---- Campaign Offer Grid: AJAX add-to-cart with a loading-dots state,
    // replacing the old real-page-reload form submit. If the section has a
    // coupon code set, it's applied via /discount/{code} before the add so
    // it's already active on whatever cart view the customer lands on.
    // Badge refresh is handled globally by campaign-cart-icon.js's fetch
    // interceptor — no need to touch it here. ----
    document.querySelectorAll('form[data-ajax-cart-form]').forEach(form => {
        const submitBtn = form.querySelector('.offer-tile__button');
        if (!submitBtn) return;

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            if (submitBtn.classList.contains('is-loading')) return;

            submitBtn.classList.add('is-loading');
            const addUrl = form.dataset.cartAddUrl || '/cart/add.js';
            const cartUrl = form.dataset.cartUrl || '/cart';
            const couponCode = form.dataset.couponCode;

            const applyCoupon = couponCode
                ? fetch(`/discount/${encodeURIComponent(couponCode)}`, { credentials: 'same-origin' }).catch(() => {})
                : Promise.resolve();

            applyCoupon
                .then(() => fetch(addUrl, {
                    method: 'POST',
                    headers: { 'Accept': 'application/json' },
                    body: new FormData(form),
                }))
                .then(res => res.json())
                .then(data => {
                    if (data.status) {
                        // Shopify returns { status, message, description } on error
                        throw new Error(data.description || data.message || 'Could not add to cart');
                    }

                    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
                        window.Rebuy.SmartCart.show();
                    } else {
                        window.location.href = cartUrl;
                    }
                })
                .catch(err => {
                    console.error('campaign-offer-grid: add to cart failed', err);
                    alert(err.message || 'Something went wrong adding this to your cart.');
                })
                .finally(() => {
                    submitBtn.classList.remove('is-loading');
                });
        });
    });

    // Variant pill buttons inside Campaign Offer Grid tiles: swap the
    // hidden variant id, update price/compare-at price, and toggle
    // sold-out state on the Add to Cart button.
    document.querySelectorAll('.offer-tile').forEach(tile => {
        const variantButtons = tile.querySelectorAll('[data-variant-btn]');
        if (!variantButtons.length) return;

        const idInput = tile.querySelector('[data-variant-id-input]');
        const priceEl = tile.querySelector('[data-tile-price]');
        const comparePriceEl = tile.querySelector('[data-tile-compare-price]');
        const submitBtn = tile.querySelector('.offer-tile__button');
        const submitLabelEl = tile.querySelector('[data-submit-label]');

        const selectVariant = (btn) => {
            variantButtons.forEach(b => b.classList.remove('is-selected'));
            btn.classList.add('is-selected');

            if (idInput) idInput.value = btn.dataset.variantId;

            const available = btn.dataset.available === 'true';
            if (submitBtn) submitBtn.disabled = !available;
            if (submitLabelEl) {
                submitLabelEl.textContent = available
                    ? (submitBtn && submitBtn.dataset.defaultLabel || 'Add to Cart')
                    : 'Sold Out';
            }

            // innerHTML (not textContent): this shop's money format wraps the
            // price in markup (e.g. <span class=money>$37.47<span class=mcode>USD</span></span>),
            // so textContent would render the tags as literal visible text.
            if (priceEl && btn.dataset.price) priceEl.innerHTML = btn.dataset.price;
            if (comparePriceEl) {
                if (btn.dataset.comparePrice) {
                    comparePriceEl.innerHTML = btn.dataset.comparePrice;
                    comparePriceEl.style.display = '';
                } else {
                    comparePriceEl.style.display = 'none';
                }
            }
        };

        variantButtons.forEach(btn => {
            btn.addEventListener('click', () => selectVariant(btn));
        });
    });
})();
